
































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import Tab from "@/components/App/Modules/GMS/Dashboard/components/Tabs.vue";
import PendingActionComponent from "@/components/App/Modules/GMS/Communication/Dashboard/PendingAction.vue";
import CommiunicationDashboardListComponent from "./CommunicationList.vue";
import CommunicationTrackerComponent from "./CommunicationTracker.vue";
import CommunicationDocumentComponent from "./CommunicationDocuments.vue";

@Component({
  components: { Tab, PendingActionComponent,CommiunicationDashboardListComponent, CommunicationTrackerComponent, CommunicationDocumentComponent },
})
export default class CommunicationSummaryComponent extends Vue {
  tabItems: any = [
    { key: "grants", component: "CommiunicationDashboardListComponent", text: "Grants" },
    { key: "tracker", component: "CommunicationTrackerComponent", text: "Tracker" },
    { key: "docs", component: "CommunicationDocumentComponent", text: "Documents" },
    { key: "pendingAction", component: "PendingActionComponent", text: "Pending Tasks" }
  ];

  activeTabComponent: string = this.tabItems[0].component;
  selectedKey = this.tabItems[0].key;
  selectedTabIndex = 0;
  items: any = [];
  filters: any = [];

  loadComponent(tab) {
    this.items = [];
    this.selectedKey = tab.key;
    window.location.hash = `#${this.selectedKey}`;
    this.activeTabComponent = tab.component;
  }

  onSearch() {

  }

  /** watch method to refresh page on page load */
  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(changedRoute: any, previousRoute: any) {
      if(changedRoute && changedRoute.name === 'Communication') {
        if(this.$route.hash) {
              this.selectedKey = this.$route.hash.substr(1);
              this.selectedTabIndex = this.tabItems.findIndex(x => x.key === this.selectedKey);
              if(this.selectedTabIndex >= 0) {
                this.activeTabComponent = this.tabItems[this.selectedTabIndex].component;
              }
        }
          else
              window.location.hash = `#${this.selectedKey}`;
      }
  }

}
